import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lead" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center p-1" }
const _hoisted_3 = { class: "d-flex flex-column align-items-center" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mt-2 font-weight-bold" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isVisible) = $event)),
    breakpoints: { '1600px': '45vw', '1200px': '50vw', '992px': '60vw', '768px': '75vw', '576px': '90vw' },
    class: "p-dialog-secondary",
    closable: true,
    header: _ctx.$t('myCadac.expertSettings.selectExpertLevel'),
    modal: true,
    style: { width: '35vw' },
    onHide: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancel()))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text p-button-plain",
        label: _ctx.$t('common.cancel'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        disabled: !_ctx.canSubmit,
        label: _ctx.$t('common.confirm'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit()))
      }, null, 8, ["disabled", "label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(`${_ctx.$t("myCadac.expertSettings.expertLevelIntro")}`), 1),
      _createVNode(_component_SelectButton, {
        modelValue: _ctx.selectedLevel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLevel) = $event)),
        class: "p-select-button-grid m-0",
        "data-key": "displayName",
        options: _ctx.options
      }, {
        option: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Avatar, {
                alt: slotProps.option?.displayName,
                class: "mb-2",
                image: slotProps.option.iconUrl,
                shape: "square",
                size: "large"
              }, null, 8, ["alt", "image"]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(slotProps.option.displayName), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "options"]),
      (_ctx.selectedLevel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("expert.expertLevelHourlyPriceRange", [
						_ctx.formatCurrency(_ctx.selectedLevel?.minPrice),
						_ctx.formatCurrency(_ctx.selectedLevel?.maxPrice),
					])), 1),
            _createElementVNode("div", {
              class: "text-preline",
              innerHTML: _ctx.selectedLevel?.description
            }, null, 8, _hoisted_7),
            _hoisted_8,
            _createElementVNode("div", {
              class: "mb-2 text-preline",
              innerHTML: _ctx.selectedLevel?.requirements
            }, null, 8, _hoisted_9),
            (_ctx.hasSelectedRequestedLevel)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  closable: false,
                  severity: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.message.awaitingExpertLevelApproval")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}